import PropTypes from 'prop-types';
import clsx from 'clsx';
import useClickAwayListener from '@shared/hooks/useClickAwayListener';
import { useRef } from 'react';
import Close from '@assets/icons/close.svg';
import useDisableScroll from '@shared/hooks/useDisableScroll';
import styles from './ModalComponent.module.scss';
import CustomText from '../CustomText';
import CustomButton from '../CustomButton';

const ModalComponent = ({
  isOpen,
  closeModal,
  title,
  mainText,
  secondaryText,
  primaryBtnText,
  secondaryBtnText,
  primaryAction,
  secondaryAction,
  maxWidth,
  disabledPrimary,
}) => {
  const modalRef = useRef();
  useClickAwayListener(modalRef, closeModal);
  useDisableScroll(isOpen);

  return isOpen ? (
    <div className={styles.overlay}>
      <div ref={modalRef} className={styles.modal} style={{ maxWidth }}>
        <button className={styles.close} onClick={closeModal}>
          <Close />
        </button>
        <CustomText customStyle={clsx('h3', styles.title)}>{title}</CustomText>
        <CustomText customStyle={clsx('body1', styles.mainText)}>
          {mainText}
        </CustomText>
        <CustomText customStyle={'subtitle2'}>{secondaryText}</CustomText>
        <div className={styles.buttons}>
          <CustomButton
            secondary
            text={secondaryBtnText}
            onClick={secondaryAction}
            customStyle={styles.secondaryButton}
          />
          <CustomButton
            disabled={disabledPrimary}
            text={primaryBtnText}
            onClick={primaryAction}
          />
        </div>
      </div>
    </div>
  ) : null;
};

ModalComponent.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  title: PropTypes.string,
  mainText: PropTypes.string,
  secondaryText: PropTypes.string,
  primaryBtnText: PropTypes.string,
  secondaryBtnText: PropTypes.string,
  disabledPrimary: PropTypes.bool,
  primaryAction: PropTypes.func,
  secondaryAction: PropTypes.func,
  maxWidth: PropTypes.number,
};

export default ModalComponent;
